import React from 'react';
import { Alert, Button } from '@trussworks/react-uswds';
import classNames from 'classnames';
import TextAreaInput from '@components/textarea/TextArea';
import { Recommendation as RequestAssistanceRecommendation } from './types';
import { getRecommendationContent, isRrsSupportRecommendation, supportEmailHref, supportEmailHours } from './helpers';
import './requestAssistance.scss';

type RecommendationProps = {
  recommendation: RequestAssistanceRecommendation;
  onBack: () => void;
  onSubmit: () => void;
  isSubmitting?: boolean;
  className?: string;
};

const Recommendation: React.FC<RecommendationProps> = ({
  recommendation,
  onBack,
  onSubmit,
  isSubmitting = false,
  className,
}) => {
  if (!recommendation) {
    return null;
  }

  const isSupportRecommendation = isRrsSupportRecommendation(recommendation);

  const containerStyles = classNames('request-assistance-recommendation', className);
  const actionsStyles = classNames('display-flex', 'gap-2', 'margin-top-2');

  if (isSupportRecommendation) {
    const recommendationContent = getRecommendationContent(recommendation);
    if (!recommendationContent) {
      return null;
    }

    return (
      <div className={containerStyles}>
        <Alert
          className='request-assistance-recommendation-alert'
          type='info'
          heading={recommendationContent.heading}
          headingLevel='h3'
        >
          <p>{recommendationContent.body}</p>
        </Alert>

        <div className={actionsStyles}>
          <Button type='button' onClick={onBack} outline>
            Back
          </Button>
          <a href={supportEmailHref} className='usa-button'>
            Email RRS Support
          </a>
        </div>
        <p className='text-base text-italic margin-top-1 margin-bottom-0'>{supportEmailHours}</p>
      </div>
    );
  }

  return (
    <div className={containerStyles}>
      <div className='margin-top-3'>
        <TextAreaInput name='reason' label='Tell us specifically what you need help with' required />
        <p className='text-base margin-top-1 margin-bottom-1'>
          Provide details about the area or areas where you need assistance. For more project-specific questions, a
          pre-application request may be recommended.
        </p>
      </div>

      <div className={actionsStyles}>
        <Button type='button' onClick={onBack} outline disabled={isSubmitting}>
          Back
        </Button>

        <Button type='button' disabled={isSubmitting} onClick={onSubmit}>
          {isSubmitting ? 'Submitting...' : 'Request Regulator Assistance'}
        </Button>
      </div>
    </div>
  );
};

export default Recommendation;
